module.exports = __webpack_public_path__ + "img/map.f055091a.svg";